<div class="dialog-content-wrapper"  fxLayout="column">
    <div>
        <mat-toolbar matDialogTitle class="header accent-700 p-24">
            <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
                <div class="contact-name mt-8">Terceiro</div>
                <button mat-icon-button (click)="dimiss()" aria-label="Close dialog">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-toolbar-row>
        </mat-toolbar>
        <div mat-dialog-content class="p-12 pb-0 m-0">
            <form [formGroup]="thirdPartyOrderItemForm" class="w-100-p">
                <div fxLayout="column" class="w-100-p">
        
                    <div fxLayout="row" class="w-100-p" fxLayoutGap="10">
        
                        <mat-form-field appearance="outline" class="w-100-p">
                            <mat-label>Terceiro</mat-label>
                            <input matInput [matAutocomplete]="autoProcedure" formControlName="thirdParty"
                                placeholder="Terceiro" type="search">
                            <mat-autocomplete autoActiveFirstOption #autoProcedure="matAutocomplete"
                                [displayWith]="displayThirdPartyFn">
                                <mat-option *ngFor="let thirdparty of thirdPartyList" [value]="thirdparty">
                                    {{ thirdparty.personName ? thirdparty.personName :
                                        thirdparty.professionalName ? thirdparty.professionalName :
                                        thirdparty.performerName ? thirdparty.performerName :
                                        thirdparty.firmName ? thirdparty.firmName : '------'}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <button mat-button matPrefix mat-icon-button class="w-10" (click)="checkType()">
                            <p matTooltip="Percentual" *ngIf="type == '1'">%</p>
                            <p matTooltip="Monetário" *ngIf="type == '2'">R$</p>
                        </button>
                        <mat-form-field class="w-20-p mr-12" *ngIf="type == '1'">
                            <mat-label>Valor</mat-label>
                            <input matInput name="value"
                                currencyMask [options]="{  suffix: '' , prefix: '' ,  allowNegative: 'false', precision: '2'}"
                                formControlName="participationValue" type="text" maxlength="6" required>
                            <mat-error *ngIf="thirdPartyOrderItemForm.get('participationValue').hasError('required')">
                                Campo é obrigatório
                            </mat-error>
                        </mat-form-field>
        
                        <mat-form-field class="w-20-p mr-12" *ngIf="type == '2'">
                            <mat-label>Valor</mat-label>
                            <input matInput name="value"
                                currencyMask [options]="{  prefix: '',  thousands: '.', decimal: ',' }" placeholder="Valor"
                                formControlName="participationValue" type="text" maxlength="10" required>
                            <mat-error *ngIf="thirdPartyOrderItemForm.get('participationValue').hasError('required')">
                                Campo é obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
        
                </div>
            </form>
        </div>
        <div mat-dialog-actions class=" m-0 p-16" fxLayout="row" fxLayoutAlign="end end">
            <button mat-raised-button (click)="dimiss()" class="mr-12">
                Cancelar
            </button>
            <button mat-raised-button [disabled]="buttonDisabled" (click)="confirm()" color="accent">
                Confirmar
            </button>
        </div>
    </div>

    <mat-table fxFlex="60" class="data-table" #table [dataSource]="orderItemThirdPartyList" matSort matSortDisableClear
    fusePerfectScrollbar>

    <ng-container matColumnDef="thirdparty">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Terceiro</mat-header-cell>
        <mat-cell *matCellDef="let orderItemThirdParty">
            <p class="text-align text-truncate">
                {{orderItemThirdParty.personName ? orderItemThirdParty.personName :
                    orderItemThirdParty.professionalName ? orderItemThirdParty.professionalName : 
                    orderItemThirdParty.performerName ? orderItemThirdParty.performerName :
                    orderItemThirdParty.firmName ? orderItemThirdParty.firmName : '------'}}
            </p>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="participationType">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Tipo de Participação</mat-header-cell>
        <mat-cell *matCellDef="let orderItemThirdParty">
            <p class="font-weight-500">
                {{orderItemThirdParty.participationType}}</p>           
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="participationValue">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Valor de Participação</mat-header-cell>
        <mat-cell *matCellDef="let orderItemThirdParty">
            <p class="font-weight-500">
                {{orderItemThirdParty.participationValue}}</p>           
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="value">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Valor do Terceiro</mat-header-cell>
        <mat-cell *matCellDef="let orderItemThirdParty">
            <p class="font-weight-500">
                R${{orderItemThirdParty.value | currency: ' '}}</p>           
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="buttons" stickyEnd>
        <mat-header-cell *matHeaderCellDef>

        </mat-header-cell>
        <mat-cell *matCellDef="let orderItemThirdParty">
            <button matTooltip="Deletar" mat-icon-button (click)="delete(orderItemThirdParty)"
            aria-label="Deletar">
            <mat-icon>delete</mat-icon>
        </button>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
    <mat-row *matRowDef="let orderItemThirdParty; columns: displayedColumns;"
     class="participation pointer">
    </mat-row>
</mat-table>
<mat-paginator #paginator [pageSize]="pageSize" [length]="totalElements" [pageIndex]="pagina" [pageIndex]="0"
[pageSizeOptions]="[5, 10, 25, 50]" (page)="getOrderItemThirdPartyList($event, 'page')"  showFirstLastButtons>
</mat-paginator>
</div>